import { AsyncPipe, CurrencyPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { OrderDirection } from '@zero/shared/util-models';
import { TradeFacade } from '@zero/trade/domain';
import { TradeCreateBuyingPowerComponent } from '../trade-create-buying-power/trade-create-buying-power.component';

@Component({
  selector: 'trade-multi-order-estimated-sum',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TradeCreateBuyingPowerComponent, TranslocoPipe, AsyncPipe, CurrencyPipe],
  templateUrl: './multi-order-estimated-sum.component.html',
  styleUrl: './multi-order-estimated-sum.component.scss',
})
export class MultiOrderEstimatedSumComponent {
  @Input() public direction: OrderDirection = 'buy';

  public readonly facade = inject(TradeFacade);
}
